import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.displaysteuerung-config-types';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungDisplaysteuerungConfigTypesEffects {

    DisplaysteuerungConfigTypes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_DISPLAYSTEUERUNG_CONFIG_TYPES),
        mergeMap((x: ac.GetDisplaysteuerungConfigTypesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getDisplaysteuerungConfigTypes().pipe(
                map((result: any) => {
                    return new ac.GetDisplaysteuerungConfigTypesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetDisplaysteuerungConfigTypesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungTemplatesService);
        }
        return this.service;
    }
}
